import classNames from 'classnames'
import React from 'react'

import Data from 'data'

import { PantheonEmbed } from '@/types/embed'
import { FormatLines, GameTooltip, statLines } from 'tooltip/common'
import { RawTooltip } from 'ui/tooltip'
import './Pantheon.scss'

export function PantheonTooltip({ id, flags }: { id: string; flags?: boolean[] }) {
  const data = Data.pantheon[id]
  if (!data) return null
  return (
    <GameTooltip className="poe-normalPopup">
      <div className="poe-content">
        <div className="poe-pantheon-name">
          <div>
            <span className="poe-lc">{data.effects[0].name}</span>
          </div>
          <div>
            <span className="poe-lc">- {data.major ? 'Major God' : 'Minor God'}- </span>
          </div>
        </div>
        <FormatLines lines={statLines('explicitMod', data.effects[0].stats)} />
        {data.effects.slice(1).map((fx, index) => (
          <React.Fragment key={index}>
            <div className="poe-separator" />
            <div className={classNames({ 'poe-colourDefault': flags?.[index] })}>
              <span className="poe-lc">
                Kill {fx.name} in {fx.area} Map
              </span>
            </div>
            <FormatLines lines={statLines(flags?.[index] ? 'explicitMod' : '', fx.stats)} />
          </React.Fragment>
        ))}
      </div>
    </GameTooltip>
  )
}

function PantheonSlot({ id, active, onSelect }: { id: string; active?: boolean[]; onSelect?: (id: string) => void }) {
  const data = Data.pantheon[id]
  const onClick = React.useCallback(() => onSelect?.(id), [onSelect, id])
  if (!data) return null
  return (
    <RawTooltip tooltip={<PantheonTooltip id={id} flags={active} />}>
      <div
        className={classNames('poe-slot', {
          'poe-major': data.major,
          'poe-active': active
        })}
        onClick={onClick}
        style={{
          left: `${((data.x * 100) / 968).toFixed(2)}cqw`,
          top: `${((data.y * 100) / 968).toFixed(2)}cqw`
        }}
      />
    </RawTooltip>
  )
}

export default function Pantheon({
  active,
  onSelect,
  style
}: {
  active: PantheonEmbed['active']
  onSelect?: (id: string) => void
  style?: React.CSSProperties
}) {
  return (
    <div className="poe-Pantheon" style={style}>
      {Object.keys(Data.pantheon).map((id) => (
        <PantheonSlot key={id} id={id} active={active[id]} onSelect={onSelect} />
      ))}
    </div>
  )
}
